import { render, staticRenderFns } from "./UserHeadImg.vue?vue&type=template&id=57c54b1a&scoped=true"
import script from "./UserHeadImg.vue?vue&type=script&lang=js"
export * from "./UserHeadImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c54b1a",
  null
  
)

export default component.exports